import styled from 'styled-components';

export const HeadingText = styled.span<{
  size?: string;
  className?: string;
  light?: boolean;
}>`
  font-size: ${({size}) => (size == null ? '80%' : size)};
  text-transform: uppercase;
  ${({light}) => (light !== true ? 'font-weight: bold;' : '')}
  letter-spacing: -0.25pt;
`;
